<template>
    <loading name="load news detail">
        <div class="container body fix-footer">
            <div class="row justify-content-center">
                <div class="col-md-8 mt-5 mb-3">
                    <div class="card">
                        <div class="card-header">
                            <h3>{{$t('pages.EditNews')}}</h3>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger" v-if="error">
                                {{$t(error)}}
                            </div>
                            <form @submit="submit">
                                <formly-form :form="form" :model="model" :fields="fields" ref="createNews"/>
                                <button type="submit" class="btn btn-primary">{{ $t('button.Save') }}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </loading>
</template>

<script>
  import isLength from 'validator/lib/isLength';
  import find from 'lodash/find';
  import { mapActions } from 'vuex';
  import { ERROR_MESSAGES, ROUTER_NAMES } from '../../constants';

  export default {
    name: 'EditNews',
    data() {
      this.statusOptions = [
        {
          label: this.$t('news.options.draft'),
          value: 'draft'
        },
        {
          label: this.$t('news.options.published'),
          value: 'published'
        },
        {
          label: this.$t('news.options.archived'),
          value: 'archived'
        },
      ];

      return {
        error: '',
        form: {},
        model: {
          title: '',
          body: '',
          short: '',
          is_featured: false,
          status: 'published',
        },
        fields: [
          {
            key: 'title',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Title')
            },
            required: true,
            validators: {
              validTitle: {
                expression(field, model, next) {
                  next(isLength(model[field.key], { min: 3 }));
                },
                message: 'Nazov musi obsahovat aspoň 3 znaky'
              }
            }
          },
          {
            key: 'image',
            type: 'image',
            templateOptions: {
              label: this.$t('fields.Image')
            },
            required: false
          },
          {
            key: 'body',
            type: 'mce',
            templateOptions: {
              label: this.$t('fields.Content'),
            },
            required: true,
            validators: {
              validShort: {
                expression(field, model, next) {
                  next(isLength(model[field.key], {
                    min: 10
                  }));
                },
                message: this.$tc('validation.min', 10)
              }
            }
          },
          {
            key: 'short',
            type: 'mce',
            templateOptions: {
              label: this.$t('fields.Short'),
            },
            required: true,
            validators: {
              validShort: {
                expression(field, model, next) {
                  next(isLength(model[field.key], {
                    min: 3,
                    max: 300
                  }));
                },
                message: this.$t('validation.minMax', {
                  min: 3,
                  max: 300
                })
              }
            }
          },
          {
            key: 'status',
            type: 'multi-select',
            options: this.statusOptions,
            templateOptions: {
              label: this.$t('fields.Status'),
              multiple: false,
              closeOnSelect: true
            },
            required: true,
          },
          {
            key: 'is_featured',
            type: 'checkbox',
            templateOptions: {
              label: this.$t('fields.SetAsTop')
            },
            required: true,
          }
        ]
      };
    },
    created() {

      this.$wait.start('load news detail');
      this.loadNews(this.slug)
        .then(() => {
          this.model = Object.assign({}, this.news);
          this.model.status = find(this.statusOptions, {value: this.news.status});
          this.$wait.end('load news detail');
        }).catch((e) => {
          const response = e.response ? e.response : {};
          if(response.status == 404) {
            this.$router.push({
              name: ROUTER_NAMES.NOT_FOUND,
              params: {
                0: ROUTER_NAMES.NOT_FOUND
              }
            })
          } else {
            this.$router.push({
              name: ROUTER_NAMES.ERROR
            })
          }
      });
    },
    computed: {
      slug() {
        return this.$route.params.slug;
      },
      news() {
        return this.$store.state.news.detail[this.slug] || {};
      },
    },
    methods: {
      ...mapActions(['editNews', 'loadNewsDetail']),
      loadNews(slug) {
        return this.loadNewsDetail({
          slug: slug
        });
      },
      submit(e) {
        e.preventDefault();

        this.$refs.createNews.validate()
          .then(() => {
            if (!this.form.$valid) return;
            const data = {
              ...this.model,
              status: this.model.status.value,
              is_featured: !!this.model.is_featured,
            };
            this.editNews(data)
              .then((response) => {

                if (data.status === 'published') {
                  this.$router.push({
                    name: ROUTER_NAMES.NEWS,
                    params: {
                      slug: this.slug
                    }
                  });
                } else {
                  this.$router.push({
                    name: ROUTER_NAMES.NEWS_UNPUBLISHED,
                    params: {
                      slug: this.slug
                    }
                  });
                }
              })
              .catch(() => {
                this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
              });
          });
      }
    }
  };
</script>

<style scoped>

</style>
